import { createContext, useContext, useEffect, useRef, useState } from "react";
import { useGetSafetyAlarmsQuery } from "./dashboard/api/safetyApiSlice";
import TopicSubscriber from "app/ws/TopicSubriber";
import { selectCompanyGuid } from "features/auth/authSlice";
import { useSelector } from "react-redux";
import HasPermission, { CanManageSafetyRequest } from "app/PermissionChecker";

const defaultValue = {
    alarms: [],
    isEmergency: false,
};

const SafetyAlarmContext = createContext(defaultValue);

export const useSafetyAlarm = () => useContext(SafetyAlarmContext);

export const SafetyAlarmProvider = ({ children }) => {

    const { data: alarms = [], isSuccess, refetch } = useGetSafetyAlarmsQuery();
    let companyGuid = useSelector(selectCompanyGuid)
    const canManageSafetyRequest = HasPermission(CanManageSafetyRequest)

    const [isEmergency, setIsEmergency] = useState(false);
    const audioRef = useRef(null);

    useEffect(() => {
        audioRef.current = new Audio('/assets/audio/alarm-1.mp3');
        audioRef.current.loop = true;
    }, []);

    useEffect(() => {
        if (!isSuccess) return;

        const hasOpenAlarms = alarms.some((a) => a.status === "OPEN");

        if (hasOpenAlarms) {
            setIsEmergency(true);
            audioRef.current.play().catch(() => {
                console.warn("Autoplay bloccato, serve interazione utente");
                audioRef.current = new Audio('/assets/audio/alarm-1.mp3');
                audioRef.current.loop = true;
                audioRef.current.play()
            });
        } else {
            setIsEmergency(false);
            audioRef.current.pause();
            audioRef.current.currentTime = 0;
        }
    }, [alarms, isSuccess]);

    return (
        <SafetyAlarmContext.Provider value={{ alarms, isEmergency }}>
            {children}
            {
                canManageSafetyRequest &&
                <TopicSubscriber
                    subTopic={`company/${companyGuid}/safety`}
                    onMessageReceived={refetch}
                />
            }

        </SafetyAlarmContext.Provider>
    );
};